import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import api from 'api';
import usePaginatedRequest from 'hooks/usePaginatedRequest';
import useQueryParams from 'hooks/useQueryParams';
import Table from 'components/Table';
import { columns, contentTransformations, headingTranslations } from './data';
import Pagination from 'components/Pagination';
import DashContentWrapper from '../../components/DashContentWrapper';
import './Fleets.styles.scss';
import './Fleets.styles.responsive.scss';

type FleetsProps = {
  className?: string;
};

const LIMIT_FLEETS = '10';

const Fleets: React.FC<FleetsProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { params, setQueryParam } = useQueryParams();

  const classes = classNames('fleets', className);

  const request = useMemo(() => api.fleet.getFleets, []);

  const {
    totalPages,
    isLoading,
    items: fleets,
  } = usePaginatedRequest({
    getItems: request,
    defaultParams: {
      limit: LIMIT_FLEETS,
      ...(params.filter ? { filter: JSON.parse(params.filter) } : {}),
    },
    dependencies: [params, request],
  });

  return (
    <DashContentWrapper className={classes}>
      <p className="fm-page-title user-title">{t('fleets')}</p>

      <Table
        data={fleets}
        columns={columns}
        headingTranslations={headingTranslations}
        tableContentTransformations={contentTransformations}
        isDataLoading={isLoading}
      />
      <Pagination
        lastPage={+totalPages}
        currentPage={+params.page || 1}
        setPage={(n) => setQueryParam('page', n)}
      />
    </DashContentWrapper>
  );
};

export default Fleets;
